import * as React from 'react';
import classNames from 'classnames';

export interface CheckboxProps extends React.HTMLProps<HTMLInputElement> {
  id?: string;
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const {
    id,
    label,
    disabled,
    className,
    onChange,
    checked = false,
    ...inputProps
  } = props;

  const checkboxClasses = classNames('ui-checkbox', className);

  return (
    <label htmlFor={id} className={checkboxClasses}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        tabIndex={0}
        className="ui-checkbox_input"
        {...inputProps}
      />
      <span className="ui-checkbox_checkmark" />
      {label && <span className="ui-checkbox-label">{label}</span>}
    </label>
  );
};

export default Checkbox;
